import { Link } from "react-router-dom";
import Seo from "../components/site/Seo";
import { PageHero, Section } from "../components/site/Bits";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { useSite } from "../lib/site";
import { Paras } from "./Funding";

export default function Faqs() {
  const { content } = useSite();
  const items = content.faqs?.items || [];
  return (
    <>
      <Seo title="Frequently Asked Questions" path="/faqs" description="Answers to common questions about NDIS equipment trials, home modifications, costs, renting and our service area in Melbourne and Victoria." />
      <PageHero eyebrow="FAQs" title="Frequently asked questions" intro="Can't find your answer? Contact us and we'll be happy to help." />
      <Section>
        <Accordion type="multiple" className="max-w-4xl space-y-3" data-testid="faq-accordion">
          {items.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="card border px-6">
              <AccordionTrigger className="min-h-[60px] py-5 text-left font-display text-lg font-semibold hover:no-underline" data-testid={`faq-trigger-${i}`}>{f.q}</AccordionTrigger>
              <AccordionContent className="pb-5 text-lg text-ink-muted"><Paras text={f.a} /></AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <Link to="/contact" className="btn-primary mt-10">Contact us</Link>
      </Section>
    </>
  );
}
